// Marquee.js
import React, { useRef, useEffect } from 'react';



const Marquee = ({ texts, speed }) => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (wrapperRef.current) {
      // Get the width of the original content (scrollWidth / 2 since we duplicate it)
      const contentWidth = wrapperRef.current.scrollWidth / 2;
      // Calculate duration based on speed (pixels per second)
      const duration = contentWidth / speed;
      wrapperRef.current.style.animationDuration = `${duration}s`;
    }
  }, [texts, speed]);

  return (
    <div className="marq-container">
      <div className="marq-text-wrapper" ref={wrapperRef}>
        {/* Render the text items once */}
        {texts.map((text, index) => (
          <span key={index}>{text}</span>
        ))}
        {/* Duplicate the text items for seamless looping */}
        {texts.map((text, index) => (
          <span key={index + texts.length}>{text}</span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;